var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total",style:({
    width: _vm.num == 6 ? '80%' : '100%',
  })},_vm._l((_vm.senddata),function(i,j){return _c('div',{key:j,staticClass:"totalimg",style:({
      backgroundImage: `url(${i.url})`,
      width: _vm.types == 0 ? '17.45vw' : _vm.types == -1 ? '36.67vw' : '23.59vw',
      height: _vm.types == 0 ? '10.42vw' : _vm.types == -1 ? '21.88vw' : '14.06vw',
      // width: '17.45vw',
    }),on:{"mouseenter":function($event){return _vm.hover(j)},"mouseleave":function($event){return _vm.hover(-1)},"click":_vm.turnto}},[(_vm.movehover == j)?_c('div',{staticClass:"mask"},[_vm._v("\n      "+_vm._s(i.title)+"\n    ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }